import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userDetails: {},
  guestCount: 1,
  confirmationNos: null
};

const confirmationNoSlice = createSlice({
  name: "confirmation",
  initialState,
  reducers: {
    userReservationDetailsConfirmatioNo: (state, action) => {
      state.userDetails = action.payload;
    },
    confNoCountOfTheGuests: (state, action) => {
      state.guestCount = state.guestCount + action.payload;
    },
    resetGuestCount: (state) => {
      state.guestCount = 0;
    },
    setMultiConfirmationNos: (state, action) => {
      state.confirmationNos = action.payload;
    },
  },
});

export const getconfirmationnumberData = (state) =>
  state.confirmation.userDetails;

export const getConfNoCurrentCountOfGuest = (state) =>
  state.confirmation.guestCount;

export const getMultiConfirmationNos = (state) =>
  state.confirmation.confirmationNos;

export const {
  userReservationDetailsConfirmatioNo,
  confNoCountOfTheGuests,
  resetGuestCount,
  setMultiConfirmationNos
} = confirmationNoSlice.actions;

export default confirmationNoSlice.reducer;
